import { z } from 'zod';
import { InspectionGradeCode } from '../../enums/crew.js';
import { enumToZodLiteralUnion, helperSchema } from '../../zodExtensions.js';
import { customFieldUiCollection } from './customField.js';
export const storeInspectionGrade = z.object({
    id: z.number(), // id on store inspection classification
    name: z.string(), // name on store inspection classification
    // code on the inspection classification
    inspectionGradeCode: enumToZodLiteralUnion(InspectionGradeCode),
});
export const storeInspectionGradeCreate = storeInspectionGrade.pick({
    id: true,
});
export const inspectionTemplate = z.object({
    name: z.string(),
    customFields: customFieldUiCollection,
    inspectionInstructions: helperSchema.optionalizedString,
    shouldCollectInspectionGrade: z.boolean(),
    showInspectionComment: z.boolean(),
    showInspectionMediaUpload: z.boolean(),
});
export const claimInspectionSettings = z.object({
    inspectionGrades: z.array(storeInspectionGrade),
    templates: z.array(inspectionTemplate),
});
//# sourceMappingURL=inspection.js.map